import * as React from 'react';

/** When `false`, `CalloutPopoverBridge` skips the popover. Defaults to `true`. */
export const CalloutGateContext = React.createContext<boolean>(true);

export function useCalloutGate(): boolean {
  return React.useContext(CalloutGateContext);
}
